export const googleConstants = {
    // Attenzione questa chiave è replicata anche nel file "public/index.html"
    API_KEY:  'AIzaSyCV1rE-ulBqJdfl54om3uf962dBrHj_txA'
};



// WEBPACK FOOTER //
// ./src/constants/google.constants.js